export const LOCK_KEY = {
    REFRESH_DATA_LOCK: "RefreshDataLock"
} as const;
